import React from "react";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell
} from "@material-ui/core";
import * as Icons from "@material-ui/icons";
import useStyles from "../../styles";

export default function LogsTable({ data, currentPage, totalPages, onPreviousPage, onNextPage }) {
  const classes = useStyles();

  if (data == null || data == [] || !!(data)) {
  } else {
    var keys = Object.keys(data[0]).map(i => i.toUpperCase());
    keys.shift();
  }

  return (
    <>
      <Table className="mb-0">
        <TableHead>
          <TableRow className={classes.root}>
            <TableCell size='small' style={{ textAlign: 'center', fontSize: "14px" }} >NOMBRE</TableCell>
            <TableCell size='small' style={{ textAlign: 'center', fontSize: "14px" }} >TIPO</TableCell>
            <TableCell size='small' style={{ textAlign: 'center', fontSize: "14px" }} >FECHA</TableCell>
            {/*{keys.map(key => (
              <TableCell key={key}>{key}</TableCell>
            ))}*/}
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map(({ id, name, type, creationDate, creationTime }) => (
            <TableRow style={{ height: "20px" }} key={id}
            //onClick={onClick(id)}
            >
              <TableCell size='small' padding='none' className={classes.tableTextStyle} style={{ fontSize: "14px" }} >{name}</TableCell>
              <TableCell size='small' padding='none' className={classes.tableTextStyle} style={{ fontSize: "14px", textAlign: 'center' }} >{type}</TableCell>
              <TableCell size='small' padding='none' className={classes.tableTextStyle} style={{ fontSize: "14px", textAlign: "center" }}>{creationDate + " " + creationTime}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <div className={classes.footerTable} style={{ float: "right" }}>
        <div className={classes.footerTableSecondDiv}>
          <p className={classes.footerText}>PÁGINA: {currentPage} DE {totalPages}</p>
          <div className={currentPage == 1 ? classes.buttonPageDisableArrowDiv :
            classes.buttonPageEnableArrowDiv}>
            <Icons.ArrowBackIos className={currentPage == 1 ?
              classes.buttonPageDisableArrow : classes.buttonPageEnableArrow}
              onClick={currentPage == 1 ? null : onPreviousPage}
            />
          </div>
          <div className={classes.spaceBetweenButtons}></div>
          <div className={currentPage == totalPages ? classes.buttonPageDisableArrowDiv :
            classes.buttonPageEnableArrowDiv}>
            <Icons.ArrowForwardIos className={currentPage == totalPages ?
              classes.buttonPageDisableArrowForward : classes.buttonPageEnableArrowForward}
              onClick={currentPage == totalPages ? null : onNextPage}
            />
          </div>
        </div>
      </div>
    </>
  );
}
